import { useRef } from "react";


window.persistantRefs = {}

class PersistantRef {
    constructor(name){
        const ref = useRef({})
        if (!('persistantRefs' in window)){
            window.persistantRefs = {}
        }
        if (!(name in window.persistantRefs)){
            window.persistantRefs[name] = ref
            this.ref = ref
        } else{
            this.ref = window.persistantRefs[name]
        }
        this.name = name
    }

    setValue(value){
        this.ref.current = value
        window.persistantRefs[this.name] = this.ref
    }

    getValue(){
        if (this.ref.current == null || Object.keys(this.ref.current).length == 0){
            if (this.name in window.persistantRefs){
                this.ref.current = window.persistantRefs[this.name].current
            }
        }
        return this.ref.current
    }

    clear(){
        this.ref.current = {}
        delete window.persistantRefs[this.name]
    }

    static clearAll(){
        if ('persistantRefs' in window){
            window.persistantRefs = {}
        }
    }
}

export default PersistantRef;

